import React from 'react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white py-10 px-4 md:px-10">
      <div className="max-w-3xl mx-auto text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Contact Admission Office</h1>
        <p className="text-gray-600 mb-8">For any queries related to admission at Khwaja Yunus Ali University, feel free to reach out.</p>

        <div className="bg-gray-100 shadow-md rounded-2xl p-6 space-y-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-700">📞 Mobile</h2>
            <p className="text-gray-600">+8801404-461555</p>
            <p className="text-gray-600">+8801404-461556</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-700">📧 Email</h2>
            <p className="text-gray-600">admission@kyau.edu.bd</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-700">👤 Admission Officer</h2>
            <p className="text-gray-600">Please contact the Admission Officer during office hours for further assistance.</p>
          </div>
        </div>

        <div className="mt-10 text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Khwaja Yunus Ali University — Online Admission System
        </div>
      </div>
    </div>
  );
};

export default Contact;
